import styled from 'styled-components';

export default styled.header`
  display: flex;
  justify-content: space-between;
  margin: 0 0 30px;
  width: 100%;
`;
